import Button, { ButtonVariant } from "../button";
import OverlayTrigger from "../overlaytrigger";
import Routing from "../routing";
import Tooltip from "../tooltip";

export interface NavigationActionProps {
  label: React.ReactNode;
  route?: string;
  variant?: ButtonVariant;
  disabled?: boolean;
  valid?: boolean;
  tooltip?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const NavigationAction = (props: Readonly<NavigationActionProps>) => {
  const {
    label,
    route,
    variant = "primary",
    valid = true,
    disabled,
    onClick,
    tooltip,
    className,
  } = props;

  let content = (
    <Button
      variant={!valid ? "danger" : variant}
      onClick={onClick}
      disabled={disabled}
      size="sm"
      className={className}
    >
      {label}
    </Button>
  );

  if (route) {
    content = <Routing to={route}>{content}</Routing>;
  }

  if (tooltip) {
    content = (
      <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
        {content}
      </OverlayTrigger>
    );
  }

  return content;
};

export default NavigationAction;
